/*
 * @Author: your name
 * @Date: 2022-01-09 18:27:27
 * @LastEditTime: 2023-05-12 00:26:35
 * @LastEditors: jyang_jun yangjun_java1002@sina.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \tongxing\src\common\config.js
 */

 /**
  * 服务端api接口地址
  */
  const baseUrl = "https://pepsicorcd.pepsico.com.cn/rcd-server"
// const baseUrl = "http://localhost:8080"
//const baseUrl = "http://106.14.188.142:8080"
//  const baseUrl = "http://rcd.olive-app.com/rcd-server"
//  http://106.14.188.142/api
//  if(dev == 'prod') {
//      baseUrl = 'https://pepsicorcd.pepsico.com.cn/rcd-server'
//  }

 /**
  * api-doc文档地址
  */
 
 const apiDocUrl = baseUrl + "/v2/api-docs"
 
 /**
  * 静态文件地址
  */
 const baseFileUrl = baseUrl + "/uploadFile/static/viewPhoto?imgPath="

 /**
  * 静态文件地址（ios系统）
  */
 const baseFileUrlIOS = baseUrl + "/uploadFile/static/iosPhoto?imgPath="
 
 /**
  * 代码生成器地址
  */
 const codeGeneratorUrl = "http://localhost:8010/api/CodeGenerators/Vue?url=" + apiDocUrl
 
 
 /** js 语法，按模块导出，不需要安装其它依赖 */
 module.exports = {
     baseUrl,
     apiDocUrl,
     baseFileUrl,
     baseFileUrlIOS,
     codeGeneratorUrl
 }